module.exports = __webpack_public_path__ + "img/stamp_blue.7dbc24ef.png";